/* eslint-disable import/no-mutable-exports */
import { zoomClasses } from '@Containers/Zoom/ZoomConstants';
import StructureZoomStorage from '@Containers/Zoom/zoomStorageNgService';
import each from 'lodash/each';
import isUndefined from 'lodash/isUndefined';
import without from 'lodash/without';

export let listeners = {};

export const unsubscribeAll = () => {
  listeners = {};
};

export const _notify = (channel, level, previousLevel) => {
  if (!listeners[channel]) return;

  each(listeners[channel], (listener) => listener(level, previousLevel));
};

export const subscribe = (channel, listener, silent) => {
  if (isUndefined(channel)) throw new Error('Context param is invalid');

  listeners[channel] = listeners[channel] ? listeners[channel] : [];
  listeners[channel]?.push(listener);

  const level = StructureZoomStorage.getZoomForKey(channel);
  // eslint-disable-next-line no-unused-expressions
  !silent && listener(level);
  return level;
};

export const unsubscribe = (channel, callback) => {
  listeners[channel] = without(listeners[channel], callback);
};

export const publish = (channel, level) => {
  const previousLevel = StructureZoomStorage.getZoomForKey(channel);
  StructureZoomStorage.storeZoomForKey(level, channel);

  _notify(channel, level, previousLevel);
};

export const getZoomClasses = (channel) => zoomClasses[channel];
